<template>
  <div class="app-page user-manager b-modal">
    <vue-headful title="ALICE | User Manager"></vue-headful>
    <div class="column-wrapper">
      <div class="single-page-full">
        <div class="navbar-wrapper">
          <nav class="navbar no-padding" role="navigation">
            <div class="navbar-start">
              <div class="navbar-item">
                <label class="label title-label">User Manager</label>
              </div>
            </div>
          </nav>
        </div>
        <div class="page-content">
          <div class="user-list">
            <label for class="label sub-label">
              <span>User List&nbsp;</span>
              <span class="tag is-info is-rounded">{{userCount}}</span>
              <div class="right-tool">
                <button class="button is-small" @click="toggleUserModal(true, 'add')">
                  <span class="icon">
                    <font-awesome-icon icon="plus"></font-awesome-icon>
                  </span>
                  <span>New User</span>
                </button>
              </div>
            </label>
            <div class="flex-section">
              <table class="table is-hoverable is-fullwidth">
                <colgroup>
                  <col span="1" style="width: 30%;" />
                  <col span="1" style="width: 40%;" />
                  <col span="1" style="width: 20%;" />
                  <col span="1" style="width: 10%;" />
                </colgroup>
                <thead>
                  <tr>
                    <th>Username</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="user in userList" :key="user.id">
                    <td>{{user.username}}</td>
                    <td>{{user.email}}</td>
                    <td>{{getUserRoleAlias(user.role)}}</td>
                    <td class="tool-column">
                      <a class="tool-btn" @click="toggleUserModal(true, 'edit', user)">
                        <font-awesome-icon icon="edit"></font-awesome-icon>
                      </a>
                      <a class="tool-btn" @click="toggleDeleteUserModal(true, user)">
                        <font-awesome-icon icon="times-circle"></font-awesome-icon>
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal general-card-modal" :class="{'is-active': userModal.open}">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <div class="card-title">
            <span v-if="userModal.mode === 'add'">Add New User</span>
            <span v-if="userModal.mode === 'edit'">Edit User</span>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Role
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <select
                    class="select is-fullwidth"
                    v-model="userModal.userData.role"
                    :disabled="userModal.mode === 'edit'"
                  >
                    <option value="user">Bot Trainer</option>
                    <option value="admin">Bot Admin</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Email
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="email"
                    placeholder="Enter email"
                    v-model="userModal.userData.email"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Username
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="text"
                    placeholder="Enter username"
                    v-model.trim="userModal.userData.username"
                    :disabled="userModal.mode === 'edit'"
                  />
                   <small class="form-text text-muted">Username must be at least 4 characters long</small>
                </div>
              </div>
            </div>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <div class="field">
                <div class="label">
                  Password
                  <sup>*</sup>
                </div>
                <div class="control is-expanded">
                  <input
                    class="input"
                    type="password"
                    :placeholder="currentPasswordPlaceholder"
                    v-model="userModal.userData.password"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="card-action">
            <button class="button is-primary" @click="saveUserModal" :disabled="invalidUserModal">
              <span v-if="userModal.mode === 'add'">Add</span>
              <span v-if="userModal.mode === 'edit'">Save</span>
            </button>
            <button class="button is-white" @click="toggleUserModal(false)">Cancel</button>
          </div>
        </div>
        <button class="modal-close is-large" aria-label="close"
                @click="toggleUserModal(false)"></button>
      </div>
    </div>
    <div class="modal general-card-modal" :class="{'is-active': deleteModal.open}">
      <div class="modal-background"></div>
      <div class="modal-content b-card">
        <div class="card no-margin">
          <div class="card-title">
            <span>Delete User</span>
          </div>
          <div class="columns is-mobile card-form">
            <div class="column">
              <span>
                You are about to delete user "{{deleteModal.username}}".
                 If you proceed, this user account will not be
                 able to access this application anymore.
              </span>
            </div>
          </div>
          <div class="card-action">
            <button class="button is-danger" @click="confirmDeleteUser">
              <span>Delete</span>
            </button>
            <button class="button is-white" @click="toggleDeleteUserModal(false)">Cancel</button>
          </div>
        </div>
      </div>
      <button class="modal-close is-large" aria-label="close"
              @click="toggleDeleteUserModal(false)"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'user-manager',
  data() {
    return {
      userModal: {
        open: false,
        mode: 'add',
        userId: '',
        userData: {
          username: '',
          password: '',
          email: '',
          role: 'user',
        },
      },
      deleteModal: {
        open: false,
        username: '',
        userId: '',
      },
    };
  },
  mounted() {
    this.reloadUserList();
  },
  methods: {
    ...mapActions({
      loadUserList: 'usermanager/loadUserList',
      addUser: 'usermanager/addUser',
      addAdmin: 'usermanager/addAdmin',
      updateUser: 'usermanager/updateUser',
      deleteUser: 'usermanager/deleteUser',
    }),
    async reloadUserList() {
      await this.loadUserList();
    },
    toggleUserModal(state, mode, data) {
      this.userModal.userData = {
        username: '',
        password: '',
        email: '',
        role: 'user',
      };
      if (state) {
        this.userModal.mode = mode;
        if (mode === 'edit') {
          this.userModal.userId = data.id;
          this.userModal.userData = {
            username: data.username,
            password: '',
            email: data.email,
            role: data.role,
          };
        }
      }
      this.userModal.open = state;
    },
    getUserRoleAlias(role) {
      if (role === 'user') {
        return 'Bot Trainer';
      }
      if (role === 'admin') {
        return 'Bot Admin';
      }
      return '';
    },
    async saveUserModal() {
      const { userData } = this.userModal;
      if (this.userModal.mode === 'add') {
        try {
          if (this.userModal.userData.role === 'user') {
            await this.addUser({ userData });
          } else if (this.userModal.userData.role === 'admin') {
            await this.addAdmin({ userData });
          }
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'New user added.',
            position: 'is-bottom',
          });
          this.reloadUserList();
        } catch (e) {
          // console.log(e);
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Add user failed.',
            position: 'is-bottom',
          });
        } finally {
          this.toggleUserModal(false);
        }
      } else if (this.userModal.mode === 'edit') {
        const { userId } = this.userModal;
        try {
          await this.updateUser({ userId, userData });
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'User info updated.',
            position: 'is-bottom',
          });
          this.reloadUserList();
        } catch (e) {
          // console.log(e);
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Update user failed.',
            position: 'is-bottom',
          });
        } finally {
          this.toggleUserModal(false);
        }
      }
    },
    toggleDeleteUserModal(state, data) {
      if (state) {
        this.deleteModal.username = data.username;
        this.deleteModal.userId = data.id;
      } else {
        this.deleteModal.username = '';
        this.deleteModal.userId = '';
      }
      this.deleteModal.open = state;
    },
    async confirmDeleteUser() {
      const { userId } = this.deleteModal;
      try {
        await this.deleteUser({ userId });
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'User deleted.',
          position: 'is-bottom',
        });
        this.reloadUserList();
      } catch (e) {
        this.$buefy.toast.open({
          type: 'is-danger',
          message: 'User delete failed.',
          position: 'is-bottom',
        });
      } finally {
        this.toggleDeleteUserModal(false);
      }
    },
    validEmail(email) {
      // eslint-disable-next-line max-len, no-useless-escape
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
  computed: {
    ...mapGetters({
      userList: 'usermanager/userList',
    }),
    invalidUserModal() {
      const { userData, mode } = this.userModal;
      const { username, email, password } = userData;
      if (!username || username.length === 0) return true;
      if (!email || email.length === 0 || !this.validEmail(email)) return true;
      if (mode === 'add') {
        if (!password || password.length === 0) return true;
      }
      return false;
    },
    currentPasswordPlaceholder() {
      if (this.userModal?.mode === 'add') {
        return 'Enter password';
      }
      return 'Leave blank if you do not want to change it.';
    },
    userCount() {
      if (this.userList) {
        return this.userList.length;
      }
      return 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.user-manager {
  user-select: none;
  .button,
  .input {
    border-radius: 5px;
  }
  .page-content {
    .user-list {
      overflow: hidden;
      flex-grow: 1;
      flex-shrink: 1;
      flex-basis: auto;
      position: relative;
      border-right: 1px solid #ddd;
      height: 100%;
      flex-direction: column;
      display: flex;
      .sub-label {
        font-size: 1em;
        padding: 1.2em 0.8em;
        line-height: 1.7rem;
        margin: 0;
      }
      .right-tool {
        float: right;
      }
      .flex-section {
        flex: 1 1 auto;
        overflow: auto;
        border-top: 1px solid #ddd;
        .table {
          td,
          th {
            font-size: 0.8rem;
          }
          th {
            color: #333;
            background-color: #eee;
          }
        }
      }
      .tool-column {
        text-align: right;
        .tool-btn {
          margin-left: 5px;
          font-size: 1rem;
          color: #333;
          cursor: pointer;
          &:hover {
            color: #888;
          }
        }
      }
    }
    .full-center-flex {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      color: #888;
      &.dark-mode {
        color: #fff;
      }
    }
  }
  .card-footer {
    justify-content: flex-end;
    padding: 10px;
    .button {
      margin-left: 10px;
    }
  }
}
</style>
